import { Controller } from "@hotwired/stimulus"

// 区画の一括選択。募集図面は8区画のものもあり、1つずつ触らせない。
export default class extends Controller {
  static targets = ["checkbox"]
  declare readonly checkboxTargets: HTMLInputElement[]

  selectAll() {
    this.setAll(true)
  }

  deselectAll() {
    this.setAll(false)
  }

  private setAll(checked: boolean) {
    this.checkboxTargets.forEach((checkbox) => {
      checkbox.checked = checked
    })
  }
}
